import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'scEmailBreak',
})
export class EmailBreakPipe implements PipeTransform {
  transform(email: string): string {
    if (!email) return '';

    return email.replace(/([@.-])/g, '<wbr>$1');
  }
}
